<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" lg="10">
        <v-card>
          <v-toolbar color="light-green darken-1" dark flat>
            <v-toolbar-title>Abteilungen</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container class="fill-height" fluid>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="12">
                  <v-form
                    name="customerform"
                    @submit.prevent=""
                    v-model="customerFormValid"
                  >
                    <v-card class="mb-12" color="grey lighten-5">
                      <v-card-title>Essenszuschuss</v-card-title>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="5">
                            <v-text-field
                              label="Abteilung"
                              type="text"
                              :disabled="subsidy.name === 'default'"
                              v-model="subsidy.name"
                            />
                          </v-col>
                          <v-col cols="12" sm="2">
                            <v-text-field
                              label="Betrag/Prozentwert"
                              type="number"
                              v-model="subsidy.amount"
                            />
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-select
                              label="Art des Zuschusses"
                              :items="typeItems"
                              v-model="subsidy.type"
                            />
                          </v-col>
                          <v-col cols="12" sm="2">
                            <v-select
                              label="Zeitraum/Essen"
                              :items="zuschussItems"
                              v-model="subsidy.perItem"
                            />
                          </v-col>
                        </v-row>
                        <h4>Limitierungen</h4>
                        <v-row class="mt-3">
                          <v-col cols="12" sm="6">
                            <v-select
                              dense
                              multiple
                              chips
                              :items="kategorien"
                              v-model="limits.hiddenCategories"
                              label="Ausgeblendete Kategorien"
                            />
                          </v-col>
                          <v-col cols="12" sm="2">
                            <v-text-field
                              label="Vorspeisen Mengenlimit"
                              type="number"
                              v-model="limits.vorspeisen.amount"
                              :disabled="isVorspeisenHidden"
                            />
                          </v-col>
                          <v-col cols="12" sm="2">
                            <v-text-field
                              label="Hauptspeisen Mengenlimit"
                              type="number"
                              v-model="limits.hauptspeisen.amount"
                              :disabled="isHauptspeisenHidden"
                            />
                          </v-col>
                          <v-col cols="12" sm="2">
                            <v-text-field
                              label="Desserts Mengenlimit"
                              type="number"
                              v-model="limits.desserts.amount"
                              :disabled="isDessertsHidden"
                            />
                          </v-col>
                        </v-row>
                        <h4>Optionen</h4>
                        <v-row>
                          <v-col v-if="Customer.restekarte">
                            <v-list>
                              <v-list-item-group
                                mandatory
                                v-model="showRestekarte"
                              >
                                <v-list-item color="red" value="not">
                                  <v-list-item-icon>
                                    <v-icon>mdi-cancel</v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Restekarte nicht anzeigen
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item color="green" value="extra">
                                  <v-list-item-icon>
                                    <v-icon>mdi-check-all</v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Restekarte zusätzlich anzeigen
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item color="green" value="only">
                                  <v-list-item-icon>
                                    <v-icon>mdi-check</v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Nur Restekarte anzeigen
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                            Zeigt für alle Mitarbeiter in der Abteilung die
                            nicht abgeholten Speisen an.
                          </v-col>
                          <v-col v-if="Customer.grossgebinde">
                            <v-switch
                              color="green"
                              label="Nur Grossgebinde anzeigen"
                              v-model="showOnlyGrossgebindeMeals"
                              persistent-hint
                              hint="Dieser Abteilung werden nur die Grossgebinde Speisen für den jeweiligen Tag angezeigt."
                            />
                          </v-col>
                        </v-row>
                        <h4 v-if="customerLieferorte.length > 0">
                          Abteilungslieferorte
                        </h4>
                        <v-row v-if="customerLieferorte.length > 0">
                          <v-col sm="8">
                            <v-select
                              multiple
                              chips
                              v-model="lieferorte"
                              :items="customerLieferorte"
                              item-text="standort"
                              item-value="_id"
                              label="Lieferorte für Abteilung"
                            />
                          </v-col>
                          <v-col sm="4">
                            <v-switch
                              color="green"
                              label="Nur Großgebinde Gerichte anzeigen"
                              v-model="showOnlyGrossgebindeMeals"
                              persistent-hint
                              hint="Mitarbeiter in der Abteilung sehen nur die Gerichte vom Großgebinde."
                            />
                          </v-col>
                        </v-row>

                        <v-row class="pa-2">
                          <v-layout column justify-end>
                            <v-btn
                              class="mr-2"
                              color="success"
                              :disabled="!subsidy.name"
                              @click="saveDepartment"
                              ><v-icon v-show="this.editIndex === -1"
                                >mdi-plus</v-icon
                              >
                              <v-icon v-show="this.editIndex !== -1"
                                >mdi-check</v-icon
                              >
                              {{
                                this.editIndex === -1
                                  ? "hinzufügen"
                                  : "speichern"
                              }}</v-btn
                            >
                          </v-layout>
                          <v-layout column>
                            <v-btn
                              color="red"
                              outlined
                              :disabled="!subsidy.name"
                              @click="clearForm"
                              ><v-icon>mdi-cancel</v-icon>
                              Abbrechen
                            </v-btn>
                          </v-layout>
                        </v-row>
                        <v-row>
                          <v-col>
                            <h3>Abteilungen Kostenzuschuss</h3>
                            <v-row class="border-bottom">
                              <v-col sm="4" offset-sm="1">
                                <h4>Abteilung</h4>
                              </v-col>
                                   <v-col sm="1">
                                <h4>Mitarbeiter</h4>
                              </v-col>
                              <v-col sm="2">
                                <h4>Zuschuss</h4>
                              </v-col>
                          
                              <v-col sm="4">
                                <h4>Art</h4>
                              </v-col>
                            </v-row>
                            <v-row
                              v-for="(item, index) in Customer.essenskosten"
                              :key="index"
                              class="border-bottom"
                            >
                              <v-col sm="1">
                                <v-icon
                                  small
                                  class="deleteDepartment ma-1"
                                  @click="removeDepartment(index)"
                                  v-if="item.name != 'default' && item.userCount == 0"
                                  >mdi-delete</v-icon
                                >

                                <v-icon
                                  small
                                  class="editDepartment ma-1"
                                  @click="editDepartment(index)"
                                  >mdi-pencil</v-icon
                                >
                              </v-col>
                              <v-col sm="4" class="border-right">
                                {{ item.name }}
                              </v-col>
                                 <v-col sm="1" class="border-right">
                                {{ item.userCount }}
                              
                              </v-col>
                              <v-col sm="2" class="border-right">
                                {{ item.amount }}
                                {{ item.type == 0 ? "€" : "%" }}
                              </v-col>
                           
                              <v-col sm="4">
                                pro {{ perItemName(item.perItem) }}
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "CustomerDepartments",
  components: {},
  data: () => ({
    lieferorte: [],
    showRestekarte: "not",
    limits: {
      hiddenCategories: [],
      vorspeisen: {
        amount: 0,
      },
      hauptspeisen: {
        amount: 0,
      },
      desserts: {
        amount: 0,
      },
    },

    subsidy: {
      name: "",
      amount: 0,
      type: 0,
      perItem: 0,
      limits: {
        hiddenCategories: [],
        vorspeisen: {
          amount: 0,
        },
        hauptspeisen: {
          amount: 0,
        },
        desserts: {
          amount: 0,
        },
      },
    },

    editIndex: -1,
    zuschussItems: [
      { text: "Essen", value: 0 },
      { text: "Tag", value: 1 },
    ],

    typeItems: [
      { text: "Fixbetrag in Euro", value: 0 },
      { text: "Prozentsatz", value: 1 },
    ],
    showOnlyGrossgebindeMeals: false,

    requiredRule: [(value) => !!value || "Dieses Feld wird benötigt!"],

    formValid: true,
    customerFormValid: false,
  }),

  methods: {
    saveDepartment() {
      if (!this.subsidy.name) {
        return;
      }

      if (this.editIndex === -1) {
        this.Customer.essenskosten.push({
          name: this.subsidy.name,
          amount: this.subsidy.amount,
          type: this.subsidy.type,
          perItem: this.subsidy.perItem,
          limits: this.limits,
          lieferorte: this.lieferorte,
          showRestekarte: this.showRestekarte,
          showOnlyGrossgebindeMeals: this.showOnlyGrossgebindeMeals,
        });
      } else {
        this.Customer.essenskosten[this.editIndex] = {
          name: this.subsidy.name,
          amount: this.subsidy.amount,
          type: this.subsidy.type,
          perItem: this.subsidy.perItem,
          limits: this.limits,
          lieferorte: this.lieferorte,
          showRestekarte: this.showRestekarte,
          showOnlyGrossgebindeMeals: this.showOnlyGrossgebindeMeals,
        };
        this.editIndex = -1;
      }
      this.save();
      //  this.clearForm();
    },

    clearForm() {
      this.editIndex = -1;
      this.subsidy.name = "";
      this.subsidy.amount = 0;
      this.subsidy.type = 0;
      this.subsidy.perItem = 0;
      this.limits.hiddenCategories = [];
      this.limits.vorspeisen.amount = 0;
      this.limits.hauptspeisen.amount = 0;
      this.limits.desserts.amount = 0;
      this.lieferorte = [];
      this.showRestekarte = "not";
      this.showOnlyGrossgebindeMeals = false;
    },
    editDepartment(index) {
      this.editIndex = index;
      if (!this.Customer.essenskosten[index].limits) {
        this.Customer.essenskosten[index].limits = this.limits;
      } else {
        this.limits = { ...this.Customer.essenskosten[index].limits };
      }

      if (!this.Customer.essenskosten[index].lieferorte) {
        this.Customer.essenskosten[index].lieferorte = this.lieferorte;
      } else {
        this.lieferorte = [...this.Customer.essenskosten[index].lieferorte];
      }

      this.showRestekarte =
        this.Customer.essenskosten[index].showRestekarte || "not";

      this.subsidy = { ...this.Customer.essenskosten[index] };
      this.showOnlyGrossgebindeMeals =
        this.Customer.essenskosten[index].showOnlyGrossgebindeMeals || false;
    },
    removeDepartment(index) {
      this.Customer.essenskosten.splice(index, 1);
      this.save();
    },
    save() {
      this.$store
        .dispatch("customer/save")
        .then(() => {
          this.clearForm();

          this.$notify({
            group: "dataline",
            type: "success",
            title: "Gespeichert",
            text: "Daten gespeichert",
          });
        })
        .catch((error) => {
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message,
            });
          }
        });
    },
    perItemName(item) {
      return this.zuschussItems.find((el) => el.value === item).text;
    },
  },
  computed: {
    defaultSubsidy() {
      return this.Customer.essenskosten.find((item) => item.name === "default");
    },
    kategorien() {
      return this.$store.getters["meal/getKategorien"];
    },

    isVorspeisenHidden() {
      return !!this.limits.hiddenCategories.find((el) => el === "Vorspeisen");
    },
    isHauptspeisenHidden() {
      return !!this.limits.hiddenCategories.find((el) => el === "Hauptspeisen");
    },
    isDessertsHidden() {
      return !!this.limits.hiddenCategories.find((el) => el === "Desserts");
    },

    Customer() {
      return this.$store.getters["customer/getCurrent"];
    },

    customerLieferorte() {
      if (!this.Customer.anlieferorte) {
        return [];
      }
      return this.Customer.anlieferorte;
    },
  },
  created() {
    const customerId = this.$store.getters["user/getUser"].customerId;
    if (!customerId) {
      this.$notify({
        group: "dataline",
        type: "error",
        title: "Fehler beim laden der Firmendaten",
        text: "Die Firmendaten konnten nicht abgerufen werden",
      });
    }

    this.$store
      .dispatch("customer/fetchCustomer", customerId)

      .then(() => {
        //this.customer = settings.data.data;
      })
      .catch((error) => {
        this.$notify({
          group: "dataline",
          type: "error",
          title: "Fehler beim laden der Einstellungen",
          text: error.message,
        });
      });
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #ccc;
}
.border-right {
  border-right: 1px solid #ccc;
}

.deleteDepartment:hover {
  color: red;
}

.editDepartment:hover {
  color: green;
}
</style>
